import AiChatPanel from "@/components/AiChatPanel";

export default function AiPlanner() {
  return (
    <div className="space-y-6" data-testid="ai-planner-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-zinc-500">Yapay Zeka</div>
        <h1 className="text-3xl mt-1">Planlama Asistanı</h1>
        <div className="text-sm text-zinc-500 mt-1">
          Projeleri, ürünleri, ustaları ve takvimi bilen asistan ile üretim planlamanı yaptır.
          Değişiklikler önce özet olarak sunulur, onayından sonra takvime işlenir.
        </div>
      </div>
      <div className="max-w-3xl">
        <AiChatPanel variant="page" />
      </div>
    </div>
  );
}
